import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";
import Button from "../../components/atoms/Button";
import StepProgress from "../../components/molecules/StepProgress";
import { useJobFilterStore } from "../../store/useJobFilterStore";

export default function CompanyInformationAdmin() {
    const navigate = useNavigate();

    const { industries, sizes, locations, fetchFilters } = useJobFilterStore();
    const location = useLocation();

    const [companyName, setCompanyName] = useState("");
    const [website, setWebsite] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [employeeSize, setEmployeeSize] = useState("");
    const [industry, setIndustry] = useState("");
    const [address, setAddress] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [about, setAbout] = useState("");

    const [photo, setPhoto] = useState<string | null>(null);

    const handleUploadPhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setPhoto(reader.result as string);
            reader.readAsDataURL(file);
        }
    };

    const handleFinish = () => {
        const lang = location.pathname.startsWith("/id") ? "id" : "en";
        navigate(`/${lang}/admin/company-profile`);
    };
    const steps = [
        { number: 1, title: "Confirmation" },
        { number: 2, title: "Personal Information" },
        { number: 3, title: "Company Information" },
    ];

    useEffect(() => {
        const currentLang = location.pathname.startsWith("/id") ? "id" : "en";
        fetchFilters(currentLang, "all");
    }, []);

    const lang = location.pathname.startsWith("/id") ? "id" : "en";


    return (
        <MainLayoutDetail>
            <div className="container-section mx-auto mt-32 px-6">

                <SectionBox background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)">
                <div className="mb-10 flex justify-center">
                    <StepProgress steps={steps} currentStep={3} />
                </div>
                    <div className="bg-white p-4 rounded-2xl shadow-md max-w-4xl mx-auto mt-6">
                        <h2 className="text-center text-2xl font-semibold text-gray-800 mb-8">
                            Basic Information
                        </h2>

                        {/* Upload Picture */}
                        <div className="flex justify-center mb-6">
                            <label className="relative cursor-pointer group">
                                <div className="w-32 h-32 rounded-full border shadow overflow-hidden bg-white">
                                    <img
                                        src={photo || "https://placehold.co/400x400"}
                                        alt="Company Avatar"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center text-white text-sm rounded-full transition">
                                    Upload picture
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleUploadPhoto}
                                />
                            </label>
                        </div>

                        {/* Form Inputs */}
                        <div className="grid md:grid-cols-2 gap-5">
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Nama Lengkap" : "Full Name"}</label>
                            <input
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                                placeholder="Company Name"
                                className="form-input"
                            />
                            </div>
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Situs Perusahaan" : "Company Website"}</label>
                            <input
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                                placeholder="Website"
                                className="form-input"
                            />
                            </div>


                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Alamat Perusahaan" : "Company Address"}</label>
                            <input
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Company Address"
                                className="form-input"
                            />
                            </div>
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Nomor Telepon" : "Phone Number"}</label>
                            <input
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                placeholder="Phone Number"
                                className="form-input"
                            />
                            </div>

                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Industri Perusahaan" : "Company Industry"}</label>
                            <select
                                value={industry}
                                onChange={(e) => setIndustry(e.target.value)}
                                className="form-input"
                            >
                                <option value="">Company Industry</option>
                                {industries.map((item: any) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            </div>

                            {/* Size of Employee */}
                            
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Jumlah Karyawan" : "Size of Employee"}</label>
                            <select
                                value={employeeSize}
                                onChange={(e) => setEmployeeSize(e.target.value)}
                                className="form-input"
                            >
                                <option value="">Size of Employee</option>
                                {sizes.map((item: any) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            </div>

                            {/* Country */}
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Negara" : "Country"}</label>
                            <select
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                className="form-input"
                            >
                                <option value="">Select Country</option>
                                {locations
                                    .filter((loc: any) => loc.country) // pastikan bukan null
                                    .map((loc: any) => (
                                        <option key={loc.id} value={loc.country}>
                                            {loc.country}
                                        </option>
                                    ))}
                            </select>
                            </div>

                            {/* City */}
                            
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Kota" : "City"}</label>
                            <select
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                className="form-input"
                            >
                                <option value="">Select City</option>
                                {locations.map((loc: any) => (
                                    <option key={loc.id} value={loc.id}>
                                        {loc.city} - {loc.state}
                                    </option>
                                ))}
                            </select>
                            </div>


                            <label className="text-sm font-medium">{lang === "id" ? "Tentang Perusahaan" : "About Company"}</label>
                            <textarea
                                value={about}
                                onChange={(e) => setAbout(e.target.value)}
                                placeholder="About Company"
                                rows={4}
                                className="form-input md:col-span-2"
                            />
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-between mt-10">
                            <Button onClick={() => navigate(-1)} className="px-10 !bg-gray-400 hover:bg-gray-500">
                                Back
                            </Button>
                            <Button onClick={handleFinish} className="px-10 bg-primary hover:bg-secondary">
                                Finish
                            </Button>
                        </div>
                    </div>
                </SectionBox>
            </div>
        </MainLayoutDetail>
    );
}
